import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const deletedResolver: FieldResolver = (metadata: Metadata) =>
  ({ deleted: metadata.isDeleted() ? true : undefined } as StreamData)

export default deletedResolver
